export default "__VITE_ASSET__Cz9hUici__"